import { render, staticRenderFns } from "./CatalogEditPage.vue?vue&type=template&id=6cd38852&scoped=true"
import script from "./CatalogEditPage.vue?vue&type=script&lang=js"
export * from "./CatalogEditPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cd38852",
  null
  
)

export default component.exports